export const SET_PAGE = "SET_PAGE"
export const SET_PAGE_SUCCESS = "SET_PAGE_SUCCESS"
export const SET_PAGE_FAIL = "SET_PAGE_FAIL"